module.exports = __webpack_public_path__ + "static/hero_bg-37d8eda28a54fc7cc64fc2ef5fea979c.jpg";